'use client';

import { getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { ADMIN_ORG_COLUMNS } from '@/app/(app)/admin/orgs/columns';
import { SetupOrgDialog } from '@/app/(app)/admin/orgs/dialog';
import { PageMain } from '@/app/(app)/page-main';
import { DataTable } from '@/components/data-table';
import { useApiV1Ctx } from '@/components/providers/v1-api';

export function AdminOrgsPage() {
  return (
    <PageMain title='Organizations'>
      <div className='flex w-full items-center justify-between'>
        <div className='flex flex-col gap-1'>
          <h1 className='text-2xl font-bold'>Organizations</h1>
          <p className='text-sm text-muted-foreground'>All organizations in the system.</p>
        </div>
        <SetupOrgDialog />
      </div>
      <Table />
    </PageMain>
  );
}

function Table() {
  const { api } = useApiV1Ctx();
  const { data } = api.organizations.getAllOrganizationsGet.useQuery();

  const table = useReactTable({
    data: data ?? [],
    columns: ADMIN_ORG_COLUMNS,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className='overflow-hidden rounded-md border'>
      <DataTable table={table} columns={ADMIN_ORG_COLUMNS} />
    </div>
  );
}
